import { defineComponent as _defineComponent } from 'vue'
import LogoIcon from '@/assets/images/logo-notice.svg?component';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPlatformNotice',
  setup(__props) {

const NEW_PLATFORM_URL = 'https://platform.oversecured.com/';

return { __sfc: true,NEW_PLATFORM_URL, LogoIcon }
}

})